
import PageLayout from '@/components/layout/PageLayout';
import { Helmet } from 'react-helmet-async';

const TermsOfService = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Terms of Service | OMAC-UK Taekwondo</title>
        <meta name="description" content="OMAC-UK Taekwondo's terms of service outlining the rules and agreements for using our services and website." />
      </Helmet>

      {/* Hero Section */}
      <div className="pt-16 pb-12 bg-gray-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold font-display mb-6">Terms of Service</h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <p className="text-lg mb-8">Effective Date: 25/03/2025</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
          <p>By accessing and using this website (OMAC-UK), you agree to these Terms of Service. If you do not agree, please discontinue use immediately.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Use of Content</h2>
          <p>This website is for informational purposes only.</p>
          <p>Unauthorised use, copying, or distribution of any content (text, images, videos) is strictly prohibited.</p>
          <p>Exception: Images of Byung-Jik Ro are not proprietary and are used for educational and historical purposes.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Intellectual Property</h2>
          <p>All images and content on this website, except those of Byung-Jik Ro, are owned by OMAC-UK or licensed for use.</p>
          <p>Users must not use, reproduce, or distribute these materials without explicit written permission.</p>
          <p>Any unauthorised use may result in legal action.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Permitted and Prohibited Uses</h2>
          <p>You may not engage in the following activities:</p>
          <p>✅ Allowed:</p>
          <p>Viewing and using the website for personal, informational, and educational purposes.</p>
          <p>🚫 Prohibited:</p>
          <p>Copying, downloading, or modifying content for commercial purposes without permission.</p>
          <p>Automated scraping, data mining, or using bots to extract content.</p>
          <p>Engaging in unlawful activities that could harm the reputation or security of OMAC-UK.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Disclaimer of Liability</h2>
          <p>While we aim to provide accurate and up-to-date information, OMAC-UK is not responsible for any errors, omissions, or outdated content.</p>
          <p>The website and its contents are provided "as is", without any warranties.</p>
          <p>OMAC-UK shall not be liable for any damages or losses resulting from reliance on information provided on this website.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">6. External Links</h2>
          <p>Our website may contain links to third-party websites.</p>
          <p>We are not responsible for their content, policies, or security practices.</p>
          <p>Users visit external links at their own risk.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Governing Law & Jurisdiction</h2>
          <p>These Terms of Service shall be governed by and construed in accordance with the laws of England and Wales.</p>
          <p>Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Modifications to Terms</h2>
          <p>OMAC-UK reserves the right to modify these terms at any time.</p>
          <p>Updates will be posted on this page, and continued use of the website implies acceptance of the updated terms.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Information</h2>
          <p>For inquiries regarding these terms, please contact us at <a href="mailto:masterjuliet@omac-uk.co.uk" className="text-taekwondo-red hover:underline">masterjuliet@omac-uk.co.uk</a>.</p>
        </div>
      </div>
    </PageLayout>
  );
};

export default TermsOfService;
